import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface AuthFormFieldProps {
  label: string;
  htmlFor: string;
  icon?: LucideIcon;
  children: React.ReactNode;
  className?: string;
}

const AuthFormField: React.FC<AuthFormFieldProps> = ({
  label,
  htmlFor,
  icon: Icon,
  children,
  className = '',
}) => (
  <div className={className}>
    <label htmlFor={htmlFor} className="mb-1.5 block text-sm font-semibold text-green-900">
      {label}
    </label>
    <div className="group relative">
      {Icon && (
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3.5">
          <Icon className="h-[18px] w-[18px] text-green-400 transition-colors group-focus-within:text-gold-600" />
        </div>
      )}
      {children}
    </div>
  </div>
);

export const authInputClass =
  'block w-full rounded-xl border border-green-200/80 bg-green-50/30 py-3 text-sm text-green-950 shadow-sm transition-all duration-200 placeholder:text-green-400/70 focus:border-gold-400 focus:bg-white focus:outline-none focus:ring-2 focus:ring-gold-400/30 disabled:cursor-not-allowed disabled:bg-green-50/50';

export const authInputWithIconClass = `${authInputClass} pr-10 pl-4`;
export const authInputPlainClass = `${authInputClass} px-4`;

export default AuthFormField;
